import { render, staticRenderFns } from "./pruritus.vue?vue&type=template&id=2dcb3ab2&scoped=true"
import script from "./pruritus.vue?vue&type=script&lang=js"
export * from "./pruritus.vue?vue&type=script&lang=js"
import style0 from "./pruritus.vue?vue&type=style&index=0&id=2dcb3ab2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb3ab2",
  null
  
)

export default component.exports